import React from 'react';
import Immutable from 'immutable';
import Profile, { fillDetails as fillProfileDetails } from './profile';
import { linkify } from '../utils/urlUtil';
import { wordFormat } from '../utils/dateFormat';

const PostRecord = Immutable.Record({
  id: 0,
  sort: 0,
  type: '',
  title: '',
  pinned: false,
  createdAt: 0,
  publishedAt: 0,
  likeCount: 0,
  commentCount: 0,
  shareCount: 0,
  permalink: '',
  consult: Immutable.Map(),
  comments: Immutable.Map(),
  author: new Profile(),
  contents: Immutable.List(),
  media: Immutable.List(),
  commentable: true,
  unlisted: false,
  blindType: '',
  blindedAt: 0
});

class Post extends PostRecord {
  get text() {
    // 블라인드
    if (this.blindType === 'C') {
      return (
        <span>
          해당 게시글은 카카오톡 채널 운영정책에서 제한하고 있는 내용이 포함되어 있음이 신고되어 {`${wordFormat(new Date(this.blindedAt))}`}에 블라인드 조치되었습니다.
          <br /><br />
          [블라인드 조치 대상] <br />
          • 음란성/도박성 등 불법성 게시물 <br />
          • 청소년 유해물 <br />
          • 비방/욕설이 포함된 게시물 <br />
          • 도배(친구신청 및 공유요청 등)게시물 <br />
          • 단순 광고,홍보성 게시물
          <br /><br />
          채널은 서비스 운영정책 및 청소년 보호 법률 준수를 위해 게시글이 블라인드 될 수 있습니다.
        </span>
      );
    }

    // 임시 조치
    if (this.blindType === 'T') {
      return (
        <span>
          해당 게시글은 권리침해신고되어 {`${wordFormat(new Date(this.blindedAt))}`}에 임시조치되었습니다.
          <br /><br />
          1. 권리침해 신고글 임시조치 안내 <br />
          권리침해신고는 '정보통신망법 제44조의 2(정보의 삭제요청 등)'과
          저작권법 103조(복제, 전송의 중단)에 의거하여 운영되는 서비스입니다.
          <br /><br />
          2. 권리침해 신고 대상 <br />
          • 명예훼손 및 개인정보침해 <br />
          • 저작권 침해
          <br /><br />
          권리침해 신고안내 (<a href="http://www.kakao.com/policy/right">http://www.kakao.com/policy/right</a>)
        </span>
      );
    }

    return linkify(this.contents);
  }

  isBlind() {
    return (this.blindType && this.blindType !== '');
  }

  getDescription() {
    return this.contents
      .filter(tv => tv.get('t') !== 'sticker')
      .map(tv => tv.get('v'))
      .join('');
  }

  getRepresentationImage() {
    const defaultImage = {
      src: this.author.profileImage.smallUrl,
      width: 110,
      height: 110,
    };

    if (this.media.isEmpty()) {
      return defaultImage;
    }

    const medium = this.media.first();
    if (medium.type === 'image') {
      return {
        src: medium.largeUrl,
        width: medium.width,
        height: medium.height
      };
    } else if (medium.type === 'video') {
      return {
        src: medium.previewImage,
        width: 640,
        height: 360
      };
    } else if (medium.type === 'link') {
      if (!medium.images.isEmpty()) {
        const firstImage = medium.images.first();
        return {
          src: firstImage.get('url'),
          width: firstImage.get('width'),
          height: firstImage.get('height')
        }
      }
    } else if (medium.type === 'card' || medium.type === 'verticalCard') {
      return {
        src: medium.medium.largeUrl,
        width: medium.medium.width,
        height: medium.medium.height
      };
    } else if (medium.type === 'couponCard') {
      return {
        src: medium.coupon.entryImage.largeUrl,
        width: medium.coupon.entryImage.width,
        height: medium.coupon.entryImage.height
      };
    }
    return defaultImage;
  }

  getSchemeHost() {
    return `plusfriend/post/${this.author.id}/${this.id}`;
  }

  getScheme(deviceName) {
    const schemeHost = this.getSchemeHost();
    if (deviceName === 'Android') {
      return `kakaoplus://${schemeHost}`;
    }
    return `${process.env.REACT_APP_PF_CUSTOM_SCHEME}://${schemeHost}`;
  }
}

export const fillDetails = (post, entities) => {
  const profiles = entities.get('profiles', Immutable.Map());
  const comments = entities.get('comments', Immutable.Map());
  return post
    .set('author', fillProfileDetails(profiles.get(`${post.author}`, new Profile()), entities), new Profile())
    .set('comments', 
      post.getIn(['comments'], Immutable.Map())
      .update('items', Immutable.List(), items => 
        items.map(key => comments.get(`${key}`))
      )
    )
    .update('media', Immutable.List(),
      media => media ? media.map(medium => {
        const schema = medium.get('schema');
        if (schema === 'couponCard') {
          return entities.getIn(['couponCards', `${medium.get('id')}`])
            .update('coupon', coupon => entities.getIn(['coupons', `${coupon}`])
              .update('entryImage', image => entities.getIn(['images', `${image}`]))
              .update('winImage', image => entities.getIn(['images', `${image}`]))
            );
        } else if (schema === 'card') {
          return entities.getIn(['cards', `${medium.get('id')}`])
            .update('medium', image => entities.getIn(['images', `${image}`]))
        } else if (schema === 'verticalCard') {
          return entities.getIn(['verticalCards', `${medium.get('id')}`])
            .update('medium', image => entities.getIn(['images', `${image}`]))
        } else if (schema === 'video') {
          return entities.getIn(['videos', `${medium.get('id')}`])
        } else if (schema === 'image') {
          return entities.getIn(['images', `${medium.get('id')}`])
        }
        return entities.getIn(['links', `${medium.get('id')}`])
      }) : Immutable.List()
    );
};

export default Post;



// WEBPACK FOOTER //
// ./src/models/post.js